// 처리현황 표의 순수 계산 — React 비의존, 단위 테스트 대상.

export interface CountRow {
  counts: Record<string, number>;
  attempts?: number;
}

export function sumCounts(c: Record<string, number>): number {
  let s = 0;
  for (const k in c) s += c[k] ?? 0;
  return s;
}

// 비율 표시. 분모 0 이하이면 "-".
export function pct(n: number, total: number): string {
  if (total <= 0) return "-";
  return `${((n / total) * 100).toFixed(1)}%`;
}

export interface BreakdownTotals {
  statusSum: Record<string, number>;
  total: number;
  attempts: number;
}

// 합계 행 계산 — 상태별 합, 상담건수 합, 연락시도 합.
export function breakdownTotals(rows: readonly CountRow[]): BreakdownTotals {
  const statusSum: Record<string, number> = {};
  let total = 0;
  let attempts = 0;
  for (const r of rows) {
    total += sumCounts(r.counts);
    attempts += r.attempts ?? 0;
    for (const k in r.counts)
      statusSum[k] = (statusSum[k] ?? 0) + (r.counts[k] ?? 0);
  }
  return { statusSum, total, attempts };
}
